// https://observablehq.com/@ridgenb/maori-factsheet@951
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Maori Factsheet`
)});
  main.variable(observer()).define(function(){return(
'Southland, WqU1+HgU1vi, 2'
)});
  main.variable(observer("fullSmapName")).define("fullSmapName", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3>${dataMapped.value.fullSmapName}</h3>`
)});
  main.variable(observer("subHeaderBar7")).define("subHeaderBar7", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3 style="background-color: #ccc; padding: 0.1em; border: 1px #aaa solid;">${dataMapped.header.headers["6"]}</h3>`
)});
  main.variable(observer("landform")).define("landform", ["dataLandformMapped","CreateLandformElement"], function(dataLandformMapped,CreateLandformElement)
{
  const data = document.createElement("div");

  for (let i = 0; i < dataLandformMapped.length; i++) {
    CreateLandformElement(
      data,
      dataLandformMapped[i].name,
      dataLandformMapped[i].technicalSummary,
      dataLandformMapped[i].tierLabel,
      `${i * 2}em`
    );
  }

  return data;
}
);
  main.variable(observer("CreateLandformElement")).define("CreateLandformElement", function(){return(
function CreateLandformElement(
  data,
  name,
  technicalSummary,
  tierLabel,
  indent
) {
  const p = document.createElement("p");
  data.appendChild(p);
  p.style.paddingLeft = indent;
  const strong = document.createElement("strong");
  strong.appendChild(document.createTextNode(tierLabel));
  p.appendChild(strong);
  p.appendChild(document.createTextNode(` - ${name}`));

  if (technicalSummary != "") {
    p.style.marginBottom = 0;
    const p1 = document.createElement("p");
    data.appendChild(p1);
    p1.style.paddingLeft = indent;
    p1.style.marginTop = 0;
    p1.appendChild(document.createTextNode(technicalSummary));
  }
}
)});
  main.variable(observer("subHeaderBar1")).define("subHeaderBar1", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3 style="background-color: #ccc; padding: 0.1em; border: 1px #aaa solid;">${dataMapped.header.headers["1"]}</h3>`
)});
  main.variable(observer("soilClassication")).define("soilClassication", ["dataMapped","CreateNoLinkGeneralPElement","CreateGeneralPElement"], function(dataMapped,CreateNoLinkGeneralPElement,CreateGeneralPElement)
{
  const data = document.createElement("div");

  if (
    dataMapped.value.nzscDescription != "" &&
    dataMapped.value.nzscDescription != null
  ) {
    CreateNoLinkGeneralPElement(
      data,
      "Soil classification:",
      dataMapped.value.nzscDescription
    );
  }

  if (
    dataMapped.value.familyName != "" &&
    dataMapped.value.familyName != null
  ) {
    CreateNoLinkGeneralPElement(
      data,
      "Family name:",
      dataMapped.value.familyName
    );
  }

  if (dataMapped.value.pMTxt != "" && dataMapped.value.pMTxt != null) {
    CreateGeneralPElement(
      data,
      "https://smap.landcareresearch.co.nz/glossary-for-stuv#soil_profile_material",
      dataMapped.header.pMTxt,
      dataMapped.value.pMTxt,
      "1em"
    );
  }

  if (
    dataMapped.value.siblingTextureTxt != "" &&
    dataMapped.value.siblingTextureTxt != null
  ) {
    let url = "https://smap.landcareresearch.co.nz/glossary-for-pqr";
    let textHeader = dataMapped.header.siblingTextureTxt;
    let textValue = dataMapped.value.siblingTextureTxt;

    CreateGeneralPElement(data, url, textHeader, textValue, "1em");
  }

  if (
    dataMapped.value.rockClassRock2 != "" &&
    dataMapped.value.rockClassRock2 != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-pqr#rock_class_of_stones/rocks";
    let textHeader = dataMapped.header.rockClassRock2;
    let textValue = dataMapped.value.rockClassRock2;

    CreateGeneralPElement(data, url, textHeader, textValue, "1em");
  }

  if (
    dataMapped.value.rockClassFines2 != "" &&
    dataMapped.value.rockClassFines2 != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-stuv#rock_origin_of_fine_earth";
    let textHeader = dataMapped.header.rockClassFines2;
    let textValue = dataMapped.value.rockClassFines2;

    CreateGeneralPElement(data, url, textHeader, textValue, "1em");
  }

  if (
    dataMapped.value.pMOriginTxt != "" &&
    dataMapped.value.pMOriginTxt != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-pqr#parent_material%20origin";
    let textHeader = dataMapped.header.pMOriginTxt;
    let textValue = dataMapped.value.pMOriginTxt;

    CreateGeneralPElement(data, url, textHeader, textValue, "1em");
  }

  if (
    dataMapped.value.fullSmapName != "" &&
    dataMapped.value.fullSmapName != null
  ) {
    CreateNoLinkGeneralPElement(
      data,
      "Sibling name:",
      dataMapped.value.fullSmapName
    );
  }

  if (
    dataMapped.value.siblingDepthTxt != "" &&
    dataMapped.value.siblingDepthTxt != null
  ) {
    CreateGeneralPElement(
      data,
      "https://smap.landcareresearch.co.nz/glossary-for-def#depth_class",
      dataMapped.header.siblingDepthTxt,
      dataMapped.value.siblingDepthTxt,
      "1em"
    );
  }

  if (
    dataMapped.value.depthRange != "" &&
    dataMapped.value.depthRange != null
  ) {
    CreateGeneralPElement(
      data,
      "https://smap.landcareresearch.co.nz/glossary-for-def#depth_class",
      dataMapped.header.depthRange,
      dataMapped.value.depthRange,
      "1em"
    );
  }

  return data;
}
);
  main.variable(observer("longSoilDescription")).define("longSoilDescription", ["html","dataMapped"], function(html,dataMapped)
{
  return html`<div><p>${dataMapped.value.longSoilDescription.replaceAll(
    "\\r\\n",
    "<br>"
  )}</p></div>`;
}
);
  main.variable(observer("photoSoilGroupSketch")).define("photoSoilGroupSketch", ["dataMapped","html"], function(dataMapped,html)
{
  if (dataMapped.soilGroupSketchUrl != null) {
    return html`<img src="${dataMapped.soilGroupSketchUrl}">`;
  } else {
    return html``;
  }
}
);
  main.variable(observer("subHeaderBar3")).define("subHeaderBar3", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3 style="background-color: #ccc; padding: 0.1em; border: 1px #aaa solid;">${dataMapped.header.headers["2"]}</h3>`
)});
  main.variable(observer("tableDescription")).define("tableDescription", ["html"], function(html){return(
html`<p style="font-weight: bold;">Characteristics of functional horizons in order from top to base of profile:</p>`
)});
  main.variable(observer("tableSibling")).define("tableSibling", ["d3","tableSiblingHead","dataTableSibling"], function(d3,tableSiblingHead,dataTableSibling)
{
  const table = d3.create("table");

  table.style({ width: "100%" });

  table
    .attr("id", "tableSibling")
    .append("thead")
    .join("tr")
    .selectAll("th")
    .data(tableSiblingHead)
    .join("th")
    .text(d => d)
    .style("background-color", "#aaa")
    .style("color", "#fff");

  table
    .append("tbody")
    .selectAll("tr")
    .data(dataTableSibling)
    .join("tr")
    .selectAll("td")
    .data(row => d3.entries(row))
    .join("td")
    .text(d => {
      if (d.value != "NULL" && d.value != "") {
        return d.value;
      } else {
        return "-";
      }
    });

  return table.node();
}
);
  main.variable(observer("tableSiblingHead")).define("tableSiblingHead", function(){return(
[
  'Functional Horizon*',
  'Thickness',
  'Stones',
  'Clay**',
  'Sand**',
  'Permeability'
]
)});
  main.variable(observer("dataTableSibling")).define("dataTableSibling", ["dataMapped"], function(dataMapped)
{
  let array = [];
  for (let i = 1; i < 7; i++) {
    if (dataMapped.value.fHTxt[i] != "") {
      array.push({
        "Functional Horizon*": dataMapped.value.fHTxt[i],
        Thickness: dataMapped.value.thickFHRange[i],
        Stones: dataMapped.value.stoneFHRange[i],
        "Clay**": dataMapped.value.clayFHRange[i],
        "Sand**": dataMapped.value.sandFHRange[i],
        Permeability: dataMapped.value.fHPermTxt[i]
      });
    }
  }
  return array;
}
);
  main.variable(observer("tableMetaText")).define("tableMetaText", ["html"], function(html){return(
html`<p>* <a href="https://smap.landcareresearch.co.nz/glossary-for-def#functional_horizons">Functional Horizons</a></p>
<p>** Clay and sand percent values are for the mineral fines (excludes stones). Silt = 100 - (clay + sand)</p>`
)});
  main.variable(observer("photoTexturePlot")).define("photoTexturePlot", ["dataMapped","html"], function(dataMapped,html)
{
  if (dataMapped.texturePlotUrl != null) {
    return html`<img src="${dataMapped.texturePlotUrl}">`;
  } else {
    return html``;
  }
}
);
  main.variable(observer("photoWaterPlot")).define("photoWaterPlot", ["dataMapped","html"], function(dataMapped,html)
{
  if (dataMapped.waterPlotUrl != null) {
    return html`<img src="${dataMapped.waterPlotUrl}">`;
  } else {
    return html``;
  }
}
);
  main.variable(observer("splineDescription")).define("splineDescription", ["dataMapped","html"], function(dataMapped,html)
{
  if (dataMapped.waterPlotUrl != null || dataMapped.texturePlotUrl != null) {
    return html`<p>The values for the graphs above have been generated from horizon and pedotransfer data. These values have then been splined to create continuous estimates of soil water holding capacity and particle size distribution the soil profile. These curves express the particle size distribution and water retention of the soil however there may be barriers to rooting depth that are not necessarily represented in these properties directly. It is advisable to check the potential rooting depth and rooting barrier fields in the soil physical properties section on page three of this factsheet.</p>`;
  } else {
    return html`<p></p>`;
  }
}
);
  main.variable(observer("subHeaderBar4")).define("subHeaderBar4", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3 style="background-color: #ccc; padding: 0.1em; border: 1px #aaa solid;">${dataMapped.header.headers["3"]}</h3>`
)});
  main.variable(observer("soilPhysicalProperties")).define("soilPhysicalProperties", ["dataMapped","CreateGeneralPElement","CreateElementPAW"], function(dataMapped,CreateGeneralPElement,CreateElementPAW)
{
  const data = document.createElement("div");

  if (
    dataMapped.value.drainageTxt != "" &&
    dataMapped.value.drainageTxt != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-def#drainage_class";
    let textHeader = dataMapped.header.drainageTxt;
    let textValue = dataMapped.value.drainageTxt;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (dataMapped.value.permTxt != "" && dataMapped.value.permTxt != null) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-pqr#permeability_profile";
    let textHeader = dataMapped.header.permTxt;
    let textValue = dataMapped.value.permTxt;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  CreateElementPAW(data);

  return data;
}
);
  main.variable(observer("CreateElementPAW")).define("CreateElementPAW", ["dataMapped"], function(dataMapped){return(
function CreateElementPAW(data) {
  const p15 = document.createElement("p");
  data.appendChild(p15);
  const a15 = document.createElement("a");
  p15.appendChild(a15);
  a15.href =
    "https://smap.landcareresearch.co.nz/glossary-for-pqr#profile_available_water_paw";
  a15.style.fontWeight = "bold";
  a15.appendChild(document.createTextNode("Water stored in the soil"));
  p15.appendChild(document.createElement("br"));
  p15.appendChild(
    document.createTextNode(
      dataMapped.header.aWmm30Txt + ": " + dataMapped.value.aWmm30Txt
    )
  );
  p15.appendChild(document.createElement("br"));
  p15.appendChild(
    document.createTextNode(
      dataMapped.header.aWmm60Txt + ": " + dataMapped.value.aWmm60Txt
    )
  );
  p15.appendChild(document.createElement("br"));
  p15.appendChild(
    document.createTextNode(
      dataMapped.header.pAWmmTxt + ": " + dataMapped.value.pAWmmTxt
    )
  );
}
)});
  main.variable(observer("subHeaderBar5")).define("subHeaderBar5", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3 style="background-color: #ccc; padding: 0.1em; border: 1px #aaa solid;">${dataMapped.header.headers["4"]}</h3>`
)});
  main.variable(observer("soilChemicalProperties")).define("soilChemicalProperties", ["dataMapped","CreateGeneralPElement"], function(dataMapped,CreateGeneralPElement)
{
  const data = document.createElement("div");

  if (dataMapped.value.pretTxt != "" && dataMapped.value.pretTxt != null) {
    let url = "https://smap.landcareresearch.co.nz/glossary-for-stuv#topsoil";
    let textHeader = dataMapped.header.pretTxt;
    let textValue = dataMapped.value.pretTxt;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  return data;
}
);
  main.variable(observer("subHeaderBar6")).define("subHeaderBar6", ["html","dataMapped"], function(html,dataMapped){return(
html`<h3 style="background-color: #ccc; padding: 0.1em; border: 1px #aaa solid;">${dataMapped.header.headers["5"]}</h3>`
)});
  main.variable(observer("soilManagementFactors1")).define("soilManagementFactors1", ["dataMapped","CreateGeneralPElement"], function(dataMapped,CreateGeneralPElement)
{
  const data = document.createElement("div");

  const h = data
    .appendChild(document.createElement("h4"))
    .appendChild(document.createTextNode("Soil structure integrity"));

  if (
    dataMapped.value.sviClassTxt != "" &&
    dataMapped.value.sviClassTxt != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-stuv#structural_vulnerability";
    let textHeader = dataMapped.header.sviClassTxt;
    let textValue = dataMapped.value.sviClassTxt;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (true) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-pqr#pugging_vulnerability";
    let textHeader = "Pugging vulnerability";
    let textValue = "Not available yet";

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.value.septicTank != "" &&
    dataMapped.value.septicTank != null
  ) {
    let url = "https://smap.landcareresearch.co.nz/glossary-for-stuv";
    let textHeader = dataMapped.header.septicTank;
    let textValue = dataMapped.value.septicTank;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  return data;
}
);
  main.variable(observer("soilManagementFactors2")).define("soilManagementFactors2", ["dataMapped","CreateGeneralPElement"], function(dataMapped,CreateGeneralPElement)
{
  const data = document.createElement("div");

  const h = data
    .appendChild(document.createElement("h4"))
    .appendChild(document.createTextNode("Contaminant management"));

  if (
    dataMapped.value.nLeachRisk != "" &&
    dataMapped.value.nLeachRisk != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-mno#n_leaching_vulnerability";
    let textHeader = dataMapped.header.nLeachRisk;
    let textValue = dataMapped.value.nLeachRisk;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.value.pLeachRisk != "" &&
    dataMapped.value.pLeachRisk != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-pqr#p_leaching_vulnerability";
    let textHeader = dataMapped.header.pLeachRisk;
    let textValue = dataMapped.value.pLeachRisk;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.value.effluentClass != "" &&
    dataMapped.value.effluentClass != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-def#dairy_effluent_FDE_risk_category";
    let textHeader = dataMapped.header.effluentClass;
    let textValue = dataMapped.value.effluentClass;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  return data;
}
);
  main.variable(observer("soilManagementFactors3")).define("soilManagementFactors3", ["dataMapped","CreateGeneralPElement"], function(dataMapped,CreateGeneralPElement)
{
  const data = document.createElement("div");

  const h = data
    .appendChild(document.createElement("h4"))
    .appendChild(document.createTextNode("Water management"));

  if (
    dataMapped.value.waterLoggedVuln != "" &&
    dataMapped.value.waterLoggedVuln != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-wxyz#waterlogging_vulnerability";
    let textHeader = dataMapped.header.waterLoggedVuln;
    let textValue = dataMapped.value.waterLoggedVuln;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.value.droughtVuln != "" &&
    dataMapped.value.droughtVuln != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-def#drought_vulnerability";
    let textHeader = dataMapped.header.droughtVuln;
    let textValue = dataMapped.value.droughtVuln;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.value.bypassFlow != "" &&
    dataMapped.value.bypassFlow != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-abc#bypass_flow";
    let textHeader = dataMapped.header.bypassFlow;
    let textValue = dataMapped.value.bypassFlow;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.value.sCSHydroGroup != "" &&
    dataMapped.value.sCSHydroGroup != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-ghi#hydrological_soil_group";
    let textHeader = dataMapped.header.sCSHydroGroup;
    let textValue = dataMapped.value.sCSHydroGroup;

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  if (
    dataMapped.header.relativeRunoffPotentialAll != "" &&
    dataMapped.header.relativeRunoffPotentialAll != null
  ) {
    let url =
      "https://smap.landcareresearch.co.nz/glossary-for-pqr#runoff_potential";
    let textHeader = dataMapped.header.relativeRunoffPotentialAll["header"];
    let textValue = "";

    CreateGeneralPElement(data, url, textHeader, textValue, "0");
  }

  return data;
}
);
  main.variable(observer("tableRunoff")).define("tableRunoff", ["d3","tableRunoffHead","dataTableRunoff"], function(d3,tableRunoffHead,dataTableRunoff)
{
  const table = d3.create("table");

  table
    .attr("id", "tableRunoff")
    .append("thead")
    .join("tr")
    .selectAll("th")
    .data(tableRunoffHead)
    .join("th")
    .text(d => d)
    .style("background-color", "#aaa")
    .style("color", "#fff");

  table
    .append("tbody")
    .selectAll("tr")
    .data(dataTableRunoff)
    .join("tr")
    .selectAll("td")
    .data(row => d3.entries(row))
    .join("td")
    .text(d => d.value);

  return table.node();
}
);
  main.variable(observer("tableRunoffHead")).define("tableRunoffHead", function(){return(
['Slope:', '0-3°', '4-7°', '8-15°', '16-25°', '>25°']
)});
  main.variable(observer("dataTableRunoff")).define("dataTableRunoff", ["dataMapped"], function(dataMapped)
{
  let array = [];
  array.push({
    "Slope:": "Risk:",
    "0-3 deg": dataMapped.value.relativeRunoffPotentialAll["0-3 deg"],
    "4-7 deg": dataMapped.value.relativeRunoffPotentialAll["4-7 deg"],
    "8-15 deg": dataMapped.value.relativeRunoffPotentialAll["8-15 deg"],
    "16-25 deg": dataMapped.value.relativeRunoffPotentialAll["16-25 deg"],
    ">25 deg": dataMapped.value.relativeRunoffPotentialAll[">25 deg"]
  });
  return array;
}
);
  main.variable(observer("photoPhoto")).define("photoPhoto", ["dataMapped","html"], function(dataMapped,html)
{
  if (dataMapped.photoUrl != null) {
    return html`<img src="${dataMapped.photoUrl}">`;
  } else {
    return html``;
  }
}
);
  main.variable(observer()).define(["md"], function(md){return(
md`## Appendix`
)});
  main.variable(observer("dataLocationEnglish")).define("dataLocationEnglish", function(){return(
'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/84e3ccfb5ebcae5c7c6bd6d75bcf560cb88c610c/TestSpatialDataEnglish.csv'
)});
  main.variable(observer("dataLocationMaori")).define("dataLocationMaori", function(){return(
'https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/84e3ccfb5ebcae5c7c6bd6d75bcf560cb88c610c/TestSpatialDataMaori.csv'
)});
  main.variable(observer("dataLocationLandform")).define("dataLocationLandform", function(){return(
"https://gist.githubusercontent.com/RenBidge/74c4cde380a6cc8c391ab990f3509827/raw/29aa44cf730565b982be7aa12940c58b3737bf22/Landform.csv"
)});
  main.variable(observer("dataSpatial")).define("dataSpatial", ["d3","dataLocationMaori"], function(d3,dataLocationMaori)
{
  return d3.csv(dataLocationMaori);
}
);
  main.variable(observer("dataLandform")).define("dataLandform", ["d3","dataLocationLandform"], function(d3,dataLocationLandform)
{
  return d3.csv(dataLocationLandform);
}
);
  main.variable(observer("dataLandformMapped")).define("dataLandformMapped", ["d3","dataLocationLandform"], function(d3,dataLocationLandform)
{
  return d3.csv(dataLocationLandform);
}
);
  main.variable(observer("dataMapped")).define("dataMapped", ["dataSpatial","FillDicts"], function(dataSpatial,FillDicts)
{
  let data = {};
  if (
    dataSpatial[0].RowType == "Value" ||
    dataSpatial[0].RowType == "ValueMaori"
  ) {
    data["value"] = JSON.parse(JSON.stringify(dataSpatial[0]));
    data["header"] = JSON.parse(JSON.stringify(dataSpatial[1]));
  } else if (
    dataSpatial[1].RowType == "Value" ||
    dataSpatial[1].RowType == "ValueMaori"
  ) {
    data["value"] = JSON.parse(JSON.stringify(dataSpatial[1]));
    data["header"] = JSON.parse(JSON.stringify(dataSpatial[0]));
  }

  FillDicts(data, "value");
  FillDicts(data, "header");

  data["photoUrl"] =
    "https://dev-api-factsheets-smap.landcareresearch.co.nz/factsheets/maori/images/photo?gisLayer=Southland&soilMapUnitCode=WqU1%2BHgU1vi&smapHubSiblingRankOrder=2";
  data["waterPlotUrl"] =
    "https://dev-api-factsheets-smap.landcareresearch.co.nz/factsheets/maori/images/waterPlot?gisLayer=Southland&soilMapUnitCode=WqU1%2BHgU1vi&smapHubSiblingRankOrder=2";
  data["texturePlotUrl"] =
    "https://dev-api-factsheets-smap.landcareresearch.co.nz/factsheets/maori/images/texturePlot?gisLayer=Southland&soilMapUnitCode=WqU1%2BHgU1vi&smapHubSiblingRankOrder=2";
  data["soilGroupSketchUrl"] =
    "https://dev-api-factsheets-smap.landcareresearch.co.nz/factsheets/maori/images/soilGroupSketch?gisLayer=Otago&soilMapUnitCode=Wn3sU&smapHubSiblingRankOrder=1";

  return data;
}
);
  main.variable(observer("CreateGeneralPElement")).define("CreateGeneralPElement", function(){return(
function CreateGeneralPElement(data, url, textHeader, textValue, indent) {
  const p = document.createElement("p");
  data.appendChild(p);
  const a = document.createElement("a");
  p.appendChild(a);
  a.href = url;
  a.style.fontWeight = "bold";
  p.style.paddingLeft = indent;
  a.appendChild(document.createTextNode(textHeader));
  p.appendChild(document.createElement("br"));
  p.appendChild(document.createTextNode(textValue));
}
)});
  main.variable(observer("CreateNoLinkGeneralPElement")).define("CreateNoLinkGeneralPElement", function(){return(
function CreateNoLinkGeneralPElement(data, textHeader, textValue, indent) {
  const p = document.createElement("p");
  data.appendChild(p);
  const span = document.createElement("span");
  p.appendChild(span);
  span.style.fontWeight = "bold";
  p.style.paddingLeft = indent;
  span.appendChild(document.createTextNode(textHeader));
  p.appendChild(document.createElement("br"));
  p.appendChild(document.createTextNode(textValue));
}
)});
  main.variable(observer("FillDicts")).define("FillDicts", function(){return(
function FillDicts(data, fillElement) {
  data[fillElement]["fHPermTxt"] = {};
  data[fillElement]["fHTxt"] = {};
  data[fillElement]["fHBulkDensity"] = {};
  data[fillElement]["clayFHRange"] = {};
  data[fillElement]["sandFHRange"] = {};
  data[fillElement]["stoneFHRange"] = {};
  data[fillElement]["thickFHRange"] = {};

  for (let i = 1; i < 7; i++) {
    data[fillElement]["fHPermTxt"][i] = data[fillElement][`fH${i}PermTxt`];
    delete data[fillElement][`fH${i}PermTxt`];

    data[fillElement]["fHTxt"][i] = data[fillElement][`fH${i}Txt`];
    delete data[fillElement][`fH${i}Txt`];

    data[fillElement]["fHBulkDensity"][i] =
      data[fillElement][`fH${i}BulkDensity`];
    delete data[fillElement][`fH${i}BulkDensity`];

    data[fillElement]["clayFHRange"][i] = data[fillElement][`clayFH${i}Range`];
    delete data[fillElement][`clayFH${i}Range`];

    data[fillElement]["sandFHRange"][i] = data[fillElement][`sandFH${i}Range`];
    delete data[fillElement][`sandFH${i}Range`];

    data[fillElement]["stoneFHRange"][i] =
      data[fillElement][`stoneFH${i}Range`];
    delete data[fillElement][`stoneFH${i}Range`];

    data[fillElement]["thickFHRange"][i] =
      data[fillElement][`thickFH${i}Range`];
    delete data[fillElement][`thickFH${i}Range`];
  }

  let runoffObjectName = "relativeRunoffPotentialAll";
  data[fillElement][runoffObjectName] = {};
  if (fillElement == "value") {
    let runoffPotentialAllSlopesSplit = data[fillElement][
      "relativeRunoffPotential"
    ]
      .substring(1)
      .split('|');

    data[fillElement][runoffObjectName][
      "0-3 deg"
    ] = runoffPotentialAllSlopesSplit[0].split(':')[1];
    data[fillElement][runoffObjectName][
      "4-7 deg"
    ] = runoffPotentialAllSlopesSplit[1].split(':')[1];
    data[fillElement][runoffObjectName][
      "8-15 deg"
    ] = runoffPotentialAllSlopesSplit[2].split(':')[1];
    data[fillElement][runoffObjectName][
      "16-25 deg"
    ] = runoffPotentialAllSlopesSplit[3].split(':')[1];
    data[fillElement][runoffObjectName][
      ">25 deg"
    ] = runoffPotentialAllSlopesSplit[4].split(':')[1];
  } else {
    data[fillElement][runoffObjectName]["header"] =
      data[fillElement]["relativeRunoffPotential"];
  }

  data[fillElement]["headers"] = {};
  for (let i = 1; i < 7; i++) {
    data[fillElement]["headers"][i] = data[fillElement][`header${i}`];
    delete data[fillElement][`header${i}`];
  }
}
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@5")
)});
  return main;
}
